import { LazyImage } from "@/components/site/LazyImage";
import { Reveal, MaskReveal } from "@/components/site/Reveal";
import { Ribbon } from "@/components/site/Ribbon";
import { img } from "@/config/images.config";
import { PROCESSES } from "@/config/site";

export default function Manufacturing() {
  return (
    <div data-testid="manufacturing-page">
      {/* HEADER */}
      <section className="relative overflow-hidden bg-navy px-6 pb-24 pt-40 text-white md:px-12 md:pb-28 md:pt-52 lg:px-16" data-testid="manufacturing-hero">
        <div className="absolute inset-0 opacity-20">
          <img src={img("weaving")} alt="Weaving" className="h-full w-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/40" />
        <div className="relative mx-auto max-w-[1600px]">
          <Reveal><p className="mb-6 font-display text-xs font-semibold uppercase tracking-[0.34em] text-sky md:text-sm">Behind the Loom</p></Reveal>
          <h1 className="font-display font-black leading-[0.9] tracking-tighter text-[clamp(2.5rem,11vw,7rem)]">
            <MaskReveal lines={["In-House", "Manufacturing"]} />
          </h1>
          <Reveal delay={0.4}>
            <p className="mt-8 max-w-3xl text-sm leading-relaxed text-white/60 md:text-base">
              From raw yarn to finished, packed goods — every stage happens under one roof. Ten controlled steps ensure consistent quality, custom specifications and reliable export-grade output.
            </p>
          </Reveal>
        </div>
      </section>

      <Ribbon />

      {/* PROCESS STEPS */}
      <section className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-28 lg:px-16" data-testid="process-list">
        <div className="space-y-20 md:space-y-32">
          {PROCESSES.map((step, i) => {
            const left = i % 2 === 0;
            return (
              <div key={step.id} className="grid items-center gap-8 md:grid-cols-2 md:gap-16" data-testid={`process-${step.id}`}>
                <Reveal className={left ? "" : "md:order-2"}>
                  <div className="overflow-hidden rounded-[2rem]">
                    <LazyImage src={img(step.id)} alt={step.title} className="aspect-[4/3] w-full" imgClassName="hover:scale-105 transition-transform duration-700" />
                  </div>
                </Reveal>
                <Reveal delay={0.1} className={left ? "" : "md:order-1"}>
                  <div className="flex items-center gap-4">
                    <span className="font-display text-5xl font-black leading-none text-sky/30 md:text-7xl">{String(i + 1).padStart(2, "0")}</span>
                    <span className="h-px flex-1 bg-navy/10" />
                  </div>
                  <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-navy md:text-5xl">{step.title}</h2>
                  <p className="mt-4 max-w-lg leading-relaxed text-navy/60 md:text-lg">{step.summary}</p>
                </Reveal>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
